import { useIsOptoutAllMessages } from '../common/utils';

import type { Props } from './types';

export default function OptoutAllMessagesWrapper({
	touchpointId,
	cloudId,
	userId,
	children,
	fallback,
	options,
}: Props) {
	const { optoutStatus } = useIsOptoutAllMessages(touchpointId, cloudId, userId, options);

	if (options?.isDisabled) {
		return children;
	}

	if (optoutStatus !== 'no-opt-out') {
		if (fallback) {
			if (typeof fallback === 'function') {
				return fallback({ optoutStatus });
			}
			return fallback;
		}
		return null;
	}

	return children;
}
